import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Rutas } from './app/rutas';
import './estilos.css';

const cola = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const contenedor = document.getElementById('root');
if (!contenedor) throw new Error('No se encontró el elemento #root.');

createRoot(contenedor).render(
  <StrictMode>
    <QueryClientProvider client={cola}>
      <BrowserRouter>
        <Rutas />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
